import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { sessionTimeoutConfig } from "../../config/sessionTimeoutConfig";


const PopupModal = ({ onRenew, showModal, setShowModal }) => {
    const [timer, setTimer] = useState(sessionTimeoutConfig.renewDurationTime);
    const { instance } = useMsal();
    

    useEffect(() => {
        let countdown = setInterval(() => {
            setTimer((prevTimer) => (prevTimer > 0 ? prevTimer - 1 : 0));
        }, 1000);

        return () => {
            clearInterval(countdown);
        };
    }, []);

    //const handleLogin = () => {
    //    instance.loginRedirect(loginRequest).catch((e) => {
    //        console.log(e);
    //    });
    //};

    //useEffect(() => {
    //    if (timer === 0) {
    //        // Redirect to the dynamic login page URL
    //       // window.location.href = handleLogin;

    //        // Optional: You may want to clear local storage or perform other cleanup actions here
    //         localStorage.clear();
    //    }
    //}, [timer]);

    useEffect(() => {
        if (timer === 0) {
            localStorage.clear();
            window.location.href = "/";
            
        }
    }, [timer, instance, loginRequest]);



    return (
        <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Your Session is about to expire in {timer} seconds.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Your session will expire in {timer} seconds, please click Renew Session to Keep the current session active.</p>
            </Modal.Body>
            <Modal.Footer>
                {/*<Button variant="secondary" onClick={() => setShowModal(false)}>*/}
                {/*    Close*/}
                {/*</Button>*/}
                <Button variant="primary" onClick={onRenew}>
                    Renew Session
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PopupModal;
